<template>
  <div>404 Error</div>
</template>

<script>
export default {
  name: "error404",
};
</script>
